import { CURRENCY_SYMBOL } from '@shootsta/common-domain-data';
import { WORD_COUNT_RANGES } from '../constants';
import { getPriceVersion } from './getPriceVersion';

const getPriceBasedOnWordsCount = (wordsCount, prices) => {
  if (!prices || !prices.length) {
    return -1;
  }

  const range = WORD_COUNT_RANGES.find((it) => wordsCount <= it.minWords);

  if (range) {
    return prices[range.priceIndex];
  }

  return -1;
};

export default function getEstimatedVoiceOverCost({
  voiceOverArtistsCount,
  wordCount,
  billingEntityCode,
  withCurrencySymbol = true,
  priceVersion = 'V2'






}) {
  const { prices } = getPriceVersion(priceVersion).find(
    (voPrice) => voPrice.billingEntityCode === billingEntityCode
  ) || {};

  const price = getPriceBasedOnWordsCount(wordCount, prices);

  if (price === -1) {
    return `${CURRENCY_SYMBOL[billingEntityCode]}XXX`;
  }

  const totalCost = price * voiceOverArtistsCount;

  return withCurrencySymbol ?
  `${CURRENCY_SYMBOL[billingEntityCode]}${totalCost.toLocaleString()}` :
  totalCost;
}